import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 92 70"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#181818",
  "fill-rule": "evenodd",
  d: "m7.63 37 27.892 29.629-2.912 2.742L.253 35 32.61.63l2.912 2.74L7.63 33H92v4z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }